import PosthogService from '~/services/posthog/PosthogService';
import type { TInviteShiftStatus } from './types';

export interface IShiftsOverviewInviteClickedPayload {
  shiftStatus: TInviteShiftStatus;
  shiftId: string;
}

/**
 * Fires when the user clicks "Invite" from the Shifts Overview page
 * Event: dental_portal:shifts_overview:invite_clicked
 */
export function fireShiftsOverviewInviteClicked(
  payload: IShiftsOverviewInviteClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:shifts_overview:invite_clicked', {
    invite_type: 'Existing Shift',
    shift_status: payload.shiftStatus,
    shift_id: payload.shiftId,
  });
}
